<template>
  <section class="catalogo-v2">
    <top-loader :pilha="topLoader" />
    <error-dialog :errorObject="modalError" @onClose="modalError = null" />
    <Navbar :uri="env.home" title="Catálogo v2" unit="Unit050"
      :selecionado="!!produtoSelecionado" @voltar="produtoSelecionado = null" />

    <div class="catalogo-conteudo">
      <div class="catalogo-barra">
        <div class="catalogo-breadcrumb">
          <a href="#" @click.prevent="$router.push(env.home)">Início</a>
          <i class="material-icons">chevron_right</i>
          <a v-if="produtoSelecionado" href="#" @click.prevent="produtoSelecionado = null">Catálogo</a>
          <template v-if="produtoSelecionado">
            <i class="material-icons">chevron_right</i>
            <span>{{ produtoSelecionado.itemDescricao }}</span>
          </template>
          <span v-else>Catálogo</span>
        </div>

        <div class="catalogo-ordenacao" v-if="!produtoSelecionado">
          <span class="grey-text">Exibindo {{ produtos.length }} resultado(s)</span>
          <select class="browser-default" v-model="busca.order" @change="pesquisar(true)">
            <option value="D">Ordenação padrão</option>
            <option value="F">Ordenar por SKU</option>
            <option value="S">Ordenar por código do produto</option>
          </select>
        </div>
      </div>

      <div class="catalogo-resultado">
        <aside class="catalogo-lateral hide-on-small-only">
          <form class="catalogo-pesquisa" @submit.prevent="pesquisar(true)">
            <input type="text" v-model.trim="busca.q" placeholder="Buscar produtos">
            <button type="submit" class="primary-color better-text" :disabled="carregando">PESQUISA</button>
          </form>

          <filtro-lateral titulo="GRUPOS DE PRODUTOS" placeholder="Buscar grupo..."
            :opcoes="filtrosDaBusca.atributo_3" :selecionados="filtrosSelecionados.atributo_3"
            @alterar="selecionarFiltro('atributo_3', $event)" />

          <filtro-lateral titulo="MARCA" placeholder="Buscar marca..."
            :opcoes="filtrosDaBusca.atributo_1" :selecionados="filtrosSelecionados.atributo_1"
            @alterar="selecionarFiltro('atributo_1', $event)" />
        </aside>

        <main class="catalogo-principal">
          <div v-if="!produtoSelecionado">
            <div v-if="!carregando && produtos.length === 0" class="card-panel center grey-text">
              Nenhum produto encontrado.
            </div>

            <div class="catalogo-grade">
              <article class="catalogo-card" v-for="produto in produtos" :key="produto.itemId"
                @click="produtoSelecionado = produto">
                <div class="catalogo-imagem">
                  <span class="catalogo-selo" v-if="produto.itemInQueimaEstoque">QUEIMA DE ESTOQUE</span>
                  <img :src="produto.fotoBaixa" :alt="produto.itemDescricao">
                </div>
                <div class="catalogo-info">
                  <strong class="catalogo-descricao">{{ produto.itemDescricao }}</strong>
                  <div class="catalogo-codigo">{{ dicionario.item_codigo }}: {{ produto.itemSku }}</div>
                  <div class="catalogo-codigo" v-if="produto.itemSkuFabricante">SKU: {{ produto.itemSkuFabricante }}</div>
                </div>
              </article>
            </div>

            <div class="center catalogo-mais" v-if="temMais">
              <button class="btn-flat waves-effect" :disabled="carregando" @click="pesquisar(false)">
                <i class="material-icons left">expand_more</i>Exibir mais produtos
              </button>
            </div>
          </div>

          <div v-else class="catalogo-detalhe">
            <button class="catalogo-voltar" @click="produtoSelecionado = null">&lt; VOLTAR CATÁLOGO</button>
            <div v-if="modoPublico || !$route.query.chatItemId" class="catalogo-detalhe-publico">
              <div class="catalogo-detalhe-imagem">
                <img :src="produtoSelecionado.fotoBaixa" :alt="produtoSelecionado.itemDescricao">
              </div>
              <div class="catalogo-detalhe-info">
                <h4>{{ produtoSelecionado.itemDescricao }}</h4>
                <p><b>{{ dicionario.item_codigo }}:</b> {{ produtoSelecionado.itemSku }}</p>
                <p v-if="produtoSelecionado.itemSkuFabricante"><b>SKU:</b> {{ produtoSelecionado.itemSkuFabricante }}</p>
                <p v-if="produtoSelecionado.itemAtributo1"><b>Marca:</b> {{ produtoSelecionado.itemAtributo1 }}</p>
                <p v-if="produtoSelecionado.itemAtributo2"><b>Montadora:</b> {{ produtoSelecionado.itemAtributo2 }}</p>
                <p v-if="produtoSelecionado.itemAtributo3"><b>Grupo:</b> {{ produtoSelecionado.itemAtributo3 }}</p>
              </div>
            </div>
            <item-viewer v-else :selecionado="produtoSelecionado" :dicionario="dicionario"
              :usuario="usuario" :env="env" :exibirPreco="false"
              :habilitarFuncaoAdicionarCarrinho="false" />
          </div>
        </main>
      </div>
    </div>
  </section>
</template>

<script>
import TopLoader from '../shared/topLoader/TopLoader.vue';
import ErrorDialog from '../shared/errorDialog/ErrorDialog.vue';
import Navbar from '../shared/nav/Navbar.vue';
import ItemViewer from '../shared/viewer/ItemViewer.vue';

const FiltroLateral = {
  props: {
    titulo: String,
    placeholder: String,
    opcoes: { type: Array, default: () => [] },
    selecionados: { type: Array, default: () => [] }
  },
  data() { return { pesquisa: '' }; },
  computed: {
    opcoesFiltradas() {
      const termo = this.pesquisa.trim().toLowerCase();
      return termo ? this.opcoes.filter(opcao => opcao.toLowerCase().includes(termo)) : this.opcoes;
    }
  },
  methods: {
    alternar(opcao) {
      const valores = this.selecionados.slice();
      const indice = valores.indexOf(opcao);
      if (indice >= 0) valores.splice(indice, 1);
      else valores.push(opcao);
      this.$emit('alterar', valores);
    },
    limpar() { this.$emit('alterar', []); }
  },
  template: `
    <section class="filtro-lateral">
      <div class="filtro-linha primary-color"></div>
      <div class="filtro-titulo">
        <h6>{{ titulo }}</h6>
        <button v-if="selecionados.length" type="button" @click="limpar">Limpar</button>
      </div>
      <input class="filtro-pesquisa" type="text" v-model="pesquisa" :placeholder="placeholder">
      <div class="filtro-opcoes">
        <label v-for="opcao in opcoesFiltradas" :key="opcao" class="filtro-opcao">
          <input type="checkbox" :checked="selecionados.includes(opcao)" @change="alternar(opcao)">
          <span>{{ opcao }}</span>
        </label>
      </div>
    </section>`
};

export default {
  components: { TopLoader, ErrorDialog, Navbar, ItemViewer, FiltroLateral },
  props: ['dicionario', 'usuario', 'env'],
  computed: {
    modoPublico() {
      return String(this.$route.query.catalogo).toLowerCase() === 'true';
    }
  },
  data() {
    return {
      topLoader: [],
      modalError: null,
      produtos: [],
      produtoSelecionado: null,
      consultaProdutoChat: 0,
      carregando: false,
      temMais: false,
      filtrosCompletos: { atributo_1: [], atributo_3: [] },
      filtrosDaBusca: { atributo_1: [], atributo_3: [] },
      filtrosSelecionados: { atributo_1: [], atributo_3: [] },
      busca: {
        q: '', sku: '', skuf: '', descricao: '', descritivo: '',
        atrib1: '', atrib2: '', atrib3: '', atrib4: '', atrib5: this.usuario.usuaIdUneg, atrib6: '',
        disp: this.env && this.env.filtro_padrao_disponibilidade || 'T',
        tabcId: null, depoId: null, emprId: null, uf: null, cateId: null,
        temSimilar: false, integracaoBling: 'T', order: 'D',
        limit: this.env && this.env.quantidade_paginacao_busca_produtos || 20, page: 0
      }
    };
  },
  created() {
    this.aplicarParametrosPublicos();
    if (!this.modoPublico && this.$route.query.chatItemId) return this.abrirProdutoChat();
    return this.pesquisar(true);
  },
  beforeDestroy() { this.consultaProdutoChat++; },
  watch: {
    '$route.query.chatItemId': function () {
      if (this.modoPublico) return;
      if (this.$route.query.chatItemId) this.abrirProdutoChat();
      else { this.consultaProdutoChat++; this.pesquisar(true); }
    },
    'usuario.usuaIdClieSelec': function () {
      if (this.modoPublico || !this.$route.query.chatItemId) return;
      this.produtoSelecionado = null;
      this.produtos = [];
      this.temMais = false;
      this.consultaProdutoChat++;
      this.abrirProdutoChat();
    }
  },
  methods: {
    abrirProdutoChat() {
      const sequence = ++this.consultaProdutoChat;
      this.produtoSelecionado = null;
      const id = Number(this.$route.query.chatItemId);
      if (!Number.isSafeInteger(id) || id <= 0) {
        this.modalError = { title: 'Produto indisponível', detail: 'O código de acesso ao produto é inválido.' };
        return Promise.resolve();
      }
      this.topLoader.push(1);
      return this.$http.get('chat/produtos/' + id).then(response => {
        if (sequence !== this.consultaProdutoChat) return;
        const product = response.body;
        this.produtoSelecionado = {
          itemId: product.id, itemSku: product.codigo, itemSkuFabricante: product.codigoFabricante,
          itemDescricao: product.descricao, itemAtributo1: product.marca, itemDescritivo: product.aplicacao,
          itemUnidade: product.unidade, tabdValor: product.precoTabela,
          fotoBaixa: 'webapi/item/' + product.id + '/fotoLow', fotoAlta: 'webapi/item/' + product.id + '/fotoHigh'
        };
      }).catch(() => {
        if (sequence !== this.consultaProdutoChat) return;
        this.modalError = { title: 'Produto indisponível', detail: 'Não foi possível abrir o produto para o cliente atual. Confira a seleção e tente novamente.' };
      }).then(() => { this.topLoader.pop(); });
    },
    aplicarParametrosPublicos() {
      const query = this.$route.query || {};
      const limite = Number(query.limite || query.limit);

      this.busca.q = query.query || query.q || '';
      this.busca.sku = query.sku || '';
      this.busca.descricao = query.descricao || '';
      this.busca.atrib1 = query.marca || query.atrib1 || '';
      this.busca.atrib2 = query.montadora || query.atrib2 || '';
      this.busca.atrib3 = query.grupo || query.atrib3 || '';
      this.busca.atrib6 = query.aplicacao || query.atrib6 || '';
      this.busca.emprId = query['id-empresa'] || query.emprId || null;
      this.busca.cateId = query['id-categoria'] || query.cateId || null;
      this.busca.exibirItemSemFoto = query['exibir-item-sem-foto'] == null
        ? !this.modoPublico
        : String(query['exibir-item-sem-foto']).toLowerCase() === 'true';
      this.busca.limit = Math.min(50, Math.max(1, Math.floor(limite > 0 ? limite : Number(this.busca.limit) || 20)));

      if (this.busca.atrib1) this.filtrosSelecionados.atributo_1 = [this.busca.atrib1];
      if (this.busca.atrib3) this.filtrosSelecionados.atributo_3 = [this.busca.atrib3];
    },
    normalizarProdutoCatalogo(item) {
      return {
        itemId: item.id,
        itemSku: item.sku,
        itemSkuFabricante: item.skuFabricante,
        itemDescricao: item.descricao,
        itemAtributo1: item.atributo1,
        itemAtributo2: item.atributo2,
        itemAtributo3: item.atributo3,
        itemAtributo4: item.atributo4,
        itemAtributo6: item.atributo6,
        itemCicloVida: item.cicloVida,
        itemInQueimaEstoque: false,
        fotoBaixa: `webapi/item/${item.id}/fotoLow`,
        fotoAlta: `webapi/item/${item.id}/fotoHigh`
      };
    },
    pesquisar(novaBusca) {
      if (this.carregando) return Promise.resolve();
      if (novaBusca) {
        this.busca.page = 0;
        this.produtos = [];
        this.produtoSelecionado = null;
      }

      this.carregando = true;
      this.topLoader.push(1);
      const consultas = this.montarConsultas();

      return Promise.all(consultas.map(parametros => this.$http.get('item/produtos', {
        params: {
          'id-empresa': parametros.emprId,
          'id-categoria': parametros.cateId,
          query: parametros.sku || parametros.q,
          'exibir-item-sem-foto': parametros.exibirItemSemFoto,
          marca: parametros.atrib1,
          montadora: parametros.atrib2,
          grupo: parametros.atrib3,
          descricao: parametros.descricao,
          aplicacao: parametros.atrib6,
          pagina: parametros.page,
          limite: parametros.limit
        }
      }).then(response => response.json())))
        .then(resultados => {
          resultados.forEach(resultado => {
            if (resultado.marcas) this.filtrosCompletos.atributo_1 = resultado.marcas;
            if (resultado.categorias) this.filtrosCompletos.atributo_3 = resultado.categorias;
          });
          const mapa = new Map(this.produtos.map(produto => [produto.itemId, produto]));
          resultados.forEach(resultado => (resultado.itens || []).forEach(item => {
            const produto = this.normalizarProdutoCatalogo(item);
            mapa.set(produto.itemId, produto);
          }));
          this.produtos = this.ordenarProdutos(Array.from(mapa.values()));
          this.temMais = resultados.some(resultado =>
            Number(resultado.pagina || 0) < Number(resultado.totalPaginas || 0)
          );
          this.busca.page += 1;
          this.atualizarOpcoesFiltros();
        })
        .catch(this.exibirErro)
        .then(() => {
          this.carregando = false;
          this.topLoader.pop();
        });
    },
    montarConsultas() {
      const marcas = this.filtrosSelecionados.atributo_1.length ? this.filtrosSelecionados.atributo_1 : [''];
      const grupos = this.filtrosSelecionados.atributo_3.length ? this.filtrosSelecionados.atributo_3 : [''];
      const consultas = [];
      marcas.forEach(marca => grupos.forEach(grupo => {
        consultas.push(Object.assign({}, this.busca, {
          atrib1: marca,
          atrib3: grupo,
          divisao: this.busca.atrib5
        }));
      }));
      return consultas;
    },
    ordenarProdutos(produtos) {
      const campo = this.busca.order === 'F' ? 'itemSkuFabricante' : this.busca.order === 'S' ? 'itemSku' : 'itemDescricao';
      return produtos.sort((a, b) => String(a[campo] || '').localeCompare(String(b[campo] || ''), 'pt-BR'));
    },
    atualizarOpcoesFiltros() {
      const temFiltro = !!(this.busca.q || this.busca.sku || this.filtrosSelecionados.atributo_1.length || this.filtrosSelecionados.atributo_3.length);
      ['atributo_1', 'atributo_3'].forEach(chave => {
        if (!temFiltro) {
          const numero = chave === 'atributo_1' ? 1 : 3;
          const encontrados = this.produtos.map(produto => produto[`itemAtributo${numero}`]).filter(Boolean);
          this.filtrosDaBusca[chave] = this.filtrosCompletos[chave].length
            ? this.filtrosCompletos[chave].slice()
            : [...new Set(encontrados)].sort();
          return;
        }
        const numero = chave === 'atributo_1' ? 1 : 3;
        const encontrados = this.produtos.map(produto => produto[`itemAtributo${numero}`]).filter(Boolean);
        this.filtrosDaBusca[chave] = [...new Set(encontrados.concat(this.filtrosSelecionados[chave]))].sort();
      });
    },
    selecionarFiltro(chave, valores) {
      this.filtrosSelecionados[chave] = valores;
      this.pesquisar(true);
    },
    exibirErro(error) { this.modalError = error; }
  }
};
</script>

<style scoped>
.catalogo-v2 { background: #fff; min-height: 100vh; color: #444; }
.catalogo-conteudo { width: calc(100% - 64px); max-width: 1500px; margin: 0 auto; padding: 24px 0 32px; }
.catalogo-barra { min-height: 78px; border-bottom: 1px solid #e5e5e5; display: flex; align-items: center; justify-content: space-between; gap: 24px; }
.catalogo-breadcrumb { display: flex; align-items: center; gap: 6px; min-width: 0; }
.catalogo-breadcrumb a { font-weight: 600; }
.catalogo-breadcrumb i { color: #aaa; font-size: 18px; }
.catalogo-breadcrumb span { color: #aaa; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.catalogo-ordenacao { display: flex; align-items: center; gap: 18px; white-space: nowrap; }
.catalogo-ordenacao select { width: 220px; height: 44px; padding: 0 12px; color: #fff; border: 0; border-radius: 3px; background: var(--primary-color, #174b91); }
.catalogo-resultado { display: flex; align-items: flex-start; padding-top: 38px; }
.catalogo-lateral { width: 270px; flex: 0 0 270px; padding-right: 24px; border-right: 1px solid #aaa; }
.catalogo-pesquisa { display: flex; margin-bottom: 18px; }
.catalogo-pesquisa input { height: 40px !important; margin: 0 !important; padding: 0 10px !important; border: 1px solid #ccc !important; box-sizing: border-box !important; font-style: italic; }
.catalogo-pesquisa button { height: 40px; border: 0; padding: 0 16px; font-weight: 700; cursor: pointer; }
.catalogo-principal { flex: 1; min-width: 0; padding-left: 40px; }
.catalogo-grade { display: grid; grid-template-columns: repeat(4, minmax(170px, 1fr)); gap: 72px 14px; }
.catalogo-card { min-width: 0; height: 100%; display: flex; flex-direction: column; cursor: pointer; transition: transform .18s ease; }
.catalogo-card:hover { transform: translateY(-4px); }
.catalogo-imagem { height: 220px; position: relative; padding: 10px; display: flex; align-items: center; justify-content: center; background: #fff; }
.catalogo-imagem img { max-width: 100%; max-height: 100%; object-fit: contain; }
.catalogo-selo { position: absolute; top: 0; left: 0; padding: 5px 7px; background: #f47a20; color: #fff; font-size: .68rem; font-weight: 700; }
.catalogo-info { height: 205px; min-width: 0; padding: 27px 24px; box-sizing: border-box; overflow: hidden; background: #f4f4f4; border-bottom: 1px solid #ccc; }
.catalogo-descricao { display: -webkit-box; height: 74px; overflow: hidden; overflow-wrap: anywhere; line-height: 1.55; text-transform: uppercase; -webkit-box-orient: vertical; -webkit-line-clamp: 3; }
.catalogo-codigo { max-width: 100%; margin-top: 12px; overflow-wrap: anywhere; font-size: .78rem; }
.catalogo-mais { padding: 35px 0; }
.catalogo-voltar { margin-bottom: 18px; padding: 8px 12px; color: #fff; background: #f39a16; border: 0; font-weight: 700; cursor: pointer; }
.catalogo-detalhe { min-height: 500px; }
.catalogo-detalhe-publico { display: grid; grid-template-columns: minmax(280px, 1.2fr) minmax(260px, 1fr); gap: 42px; align-items: start; }
.catalogo-detalhe-imagem { min-height: 420px; display: flex; align-items: center; justify-content: center; }
.catalogo-detalhe-imagem img { max-width: 100%; max-height: 520px; object-fit: contain; }
.catalogo-detalhe-info { padding: 18px 0; }
@media (max-width: 1100px) { .catalogo-grade { grid-template-columns: repeat(3, minmax(170px, 1fr)); } }
@media (max-width: 800px) { .catalogo-conteudo { width: calc(100% - 24px); } .catalogo-principal { padding-left: 0; } .catalogo-grade { grid-template-columns: repeat(2, minmax(140px, 1fr)); } .catalogo-barra, .catalogo-ordenacao { align-items: flex-start; flex-direction: column; } .catalogo-barra { padding: 18px 0; } .catalogo-detalhe-publico { grid-template-columns: 1fr; } }
@media (max-width: 500px) { .catalogo-grade { grid-template-columns: 1fr; } }
</style>

<style>
.catalogo-v2 .filtro-lateral { margin-bottom: 22px; }
.catalogo-v2 .filtro-linha { height: 2px; margin-bottom: 14px; }
.catalogo-v2 .filtro-titulo { display: flex; align-items: center; justify-content: space-between; gap: 8px; }
.catalogo-v2 .filtro-titulo h6 { margin: 0 0 10px; font-weight: 800; }
.catalogo-v2 .filtro-titulo button { padding: 0; border: 0; background: transparent; color: #777; cursor: pointer; }
.catalogo-v2 .filtro-pesquisa { height: 34px !important; margin: 0 0 8px !important; padding: 0 9px !important; border: 1px solid #ddd !important; box-sizing: border-box !important; background: #f5f5f5 !important; }
.catalogo-v2 .filtro-opcoes { max-height: 315px; overflow-y: auto; padding-right: 4px; }
.catalogo-v2 .filtro-opcao { display: flex; align-items: flex-start; gap: 7px; min-height: 26px; cursor: pointer; }
.catalogo-v2 .filtro-opcao input { position: static !important; opacity: 1 !important; pointer-events: auto !important; margin-top: 4px; }
.catalogo-v2 .filtro-opcao span { padding: 0 !important; color: #555; font-size: .82rem; line-height: 1.5; text-transform: uppercase; }
.catalogo-v2 .filtro-opcao span::before, .catalogo-v2 .filtro-opcao span::after { display: none !important; }
</style>



// WEBPACK FOOTER //
// src/components/units/Unit050.vue?57e1c3bc